import { AppShell } from '@mantine/core'
import HeroSection from './components/HeroSection'
import ServiceSection from './components/ServiceSection'
import QueryTypesSection from './components/QueryTypesSection'
import BoundarySection from './components/BoundarySection'
import DataRetentionSection from './components/DataRetentionSection'
import FAQSection from './components/FAQSection'
import Footer from './components/Footer'

export default function Home() {
  return (
    <AppShell>
      <AppShell.Main>
        <HeroSection />
        <ServiceSection />
        <QueryTypesSection />
        <BoundarySection />
        <DataRetentionSection />
        <FAQSection />
        <Footer />
      </AppShell.Main>
    </AppShell>
  )
}
